<template>
  <DefaultLayout>
    <BlogLayout
      :heading="heading"
      :breadcrumbItems="breadcrumbItems"
      :categoryLinks="categoryLinks"
      :showForNewsroomSidebar="true"
      :multiMediaData="multiMediaData"
      :breadcrumbHeadingTag="isListPage ? '' : 'div'"
    >
      <slot />
    </BlogLayout>
  </DefaultLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import DefaultLayout from "~/layouts/default.vue";
import BlogLayout from "~/layouts/blogLayout.vue";
import type { ContentItem, BreadcrumbItem, CategoryLink } from "~~/shared/types/common";
import { URL_CONFIG } from "~~/shared/utils/url.const";

const route = useRoute();

withDefaults(
  defineProps<{
    heading?: string;
    categoryLinks?: CategoryLink[];
    items?: ContentItem[];
    breadcrumbItems?: BreadcrumbItem[];
    isListPage?: boolean
  }>(),
  {
    heading: "Newsroom",
    categoryLinks: () => [],
    items: () => [],
    breadcrumbItems: () => [],
    isListPage: false
  }
);

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Home", href: "/" },
  { label: "Who We Are", href: URL_CONFIG.WHO_WE_ARE },
  { label: "Newsroom", href: URL_CONFIG.NEWS_ROOM },
];

const categoryLinks = computed(() => {
  const normalize = (p) => {
  let end = p.length;
  while (end > 0 && p[end - 1] === '/') {
    end--;
  }
  return p.slice(0, end);
};
  const path = normalize(route.path);

  return [
    { label: "Clinical Research ", href: URL_CONFIG.CLINICAL_RESEARCH },
    { label: "Collaborations", href: URL_CONFIG.STRATEGIC_COLLABORATIONS },
    { label: "Leadership", href: URL_CONFIG.COMPANY_LEADERSHIP },
    { label: "Newsroom", href: URL_CONFIG.NEWS_ROOM },
    { label: "Awards", href: URL_CONFIG.COMPANY_AWARDS },
  ].map((link) => {
    const href = normalize(link.href);
    const singular = href.endsWith("s") ? href.slice(0, -1) : null;

    const isNewsroomLink = link.href === URL_CONFIG.NEWS_ROOM;
    const isPressReleasesPath = path.startsWith(URL_CONFIG.NEWS_ROOM_DETAIL + "/");

    return {
      ...link,
      active: path === href || (singular && path.startsWith(singular + "/")) || (isNewsroomLink && isPressReleasesPath),
    };
  });
});

const multiMediaData = [
  {
    title: "Thorne Videos on Youtube",
    href: URL_CONFIG.MULTI_MEDIA_YOUTUBE_LINK,
    target: "_blank",
    icon: "youtube",
  },
  {
    title: "Thorne Podcast on Take 5 Daily",
    href: URL_CONFIG.TAKE_FIVE_PODCASTS,
    target: "_blank",
    icon: "podcast",
  },
  {
    title: "Thorne Podcast on Spotify",
    href: URL_CONFIG.MULTI_MEDIA_PODCAST_URL,
    icon: "spotify",
    target: "_blank",
    packPrefix: "fab",
  },
];
</script>
